import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class BadFilenameFail extends UploadFail {
    static BAD_FILENAME = 'BAD/FILENAME';

    radarName = 'fail_{SOURCE}_violated-filename';
    message = `test`;
}
